import { render } from "./PageNav.vue?vue&type=template&id=3e670f76&scoped=true"
import script from "./PageNav.vue?vue&type=script&lang=js"
export * from "./PageNav.vue?vue&type=script&lang=js"

import "./PageNav.vue?vue&type=style&index=0&id=3e670f76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e670f76"]])

export default __exports__